module.exports = __webpack_public_path__ + "img/content-1.ce58b4b4.png";